import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Divider, Typography } from '@mui/material';
import ProductListContainer from './ProductListContainer';
import ProductExpandCollapse from './ProductExpandCollapse';

export default function ProductListByOrderId({orderid}) {

    const { productList } = useSelector((state) => state.pharmaslice);
    const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard)
    const [productListByOrderId, setProductListByOrderId] = useState([])

    useEffect(() => {

        if (orderid!==undefined)
            setProductListByOrderId(
                productList.filter((obj) => obj.orderid === orderid)
            );
        else
            setProductListByOrderId(
                productList.filter((obj) => obj.orderid === pharmaorderObj.orderid)
            );

    }, [])

    useEffect(() => {
        if (orderid!==undefined)
            setProductListByOrderId(
                productList.filter((obj) => obj.orderid === orderid)
            );
        else
            setProductListByOrderId(
                productList.filter((obj) => obj.orderid === pharmaorderObj.orderid)
            );
    }, [productList])

    return (
        <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll",  maxHeight: { xs: '40vh', lg: '55vh' } }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{width:'100%', backgroundColor:'white'}}
                    padding={.25}
                >
                    {productListByOrderId.length>0 && productListByOrderId.map(productObj => {
                        return <ProductListContainer containedComponent={
                            <Grid>
                                <ProductExpandCollapse productObj={productObj}/>
                            </Grid>
                        } />
                    })}
                </Grid>
                {
                        productListByOrderId.length===0?
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{width:'100%', backgroundColor:'#fafafa'}}
                            padding={1}
                        >
                            <Typography sx={{ fontWeight: 'light',fontSize: 14 }}><i>Product(s) are not added, yet.</i></Typography>
                        </Grid>
                        :<></>
                    }
            </Grid>

            
        </Box>

    )
}